<template>
       <el-dialog
        title="选择院校筛选条件"
        :visible.sync="dialogVisible"
        append-to-body
        top="2vh"
        v-loading="loading"
        width="60%">
        <div style="width: 95%;margin: 0 auto;height: 98%;margin-top: 1%;">
        <el-checkbox :indeterminate="indeterminate" v-model="checkAll" @change="handleCheckAllChange">地区选择</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="cityCheckList" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="item in cityArr" :label="item.title" :key="item.title">{{item.title}}</el-checkbox>
            </el-checkbox-group>
        </div>

        <div style="width: 95%;margin: 0 auto;height: 98%;margin-top: 1%;">
        <el-checkbox :indeterminate="indeterminate01" v-model="checkAll01" @change="handleCheckAllChange01">院校类型</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="cityCheckList01" @change="handleCheckedCitiesChange01">
                <el-checkbox v-for="item in cityArr01" :label="item" :key="item">{{item}}</el-checkbox>
            </el-checkbox-group>
        </div>

        <div style="width: 95%;margin: 0 auto;height: 98%;margin-top: 1%;">
        <el-checkbox :indeterminate="indeterminate02" v-model="checkAll02" @change="handleCheckAllChange02">院校性质</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="cityCheckList02" @change="handleCheckedCitiesChange02">
                <el-checkbox v-for="item in cityArr02" :label="item" :key="item">{{item}}</el-checkbox>
            </el-checkbox-group>
        </div>

        <div style="width: 95%;margin: 0 auto;height: 98%;margin-top: 1%;">
        <el-checkbox :indeterminate="indeterminate03" v-model="checkAll03" @change="handleCheckAllChange03">院校属性</el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="cityCheckList03" @change="handleCheckedCitiesChange03">
                <el-checkbox style="width: 200px;" v-for="item in cityArr03" :label="item" :key="item">{{item}}</el-checkbox>
            </el-checkbox-group>
        </div>
        <div style="width: 95%;margin: 0 auto;height: 98%;margin-top: 1%;">
        <el-checkbox :indeterminate="indeterminate04" v-model="checkAll04" @change="handleCheckAllChange04">学校实力</el-checkbox></el-checkbox>
            <div style="margin: 15px 0;"></div>
            <el-checkbox-group v-model="cityCheckList04" @change="handleCheckedCitiesChange04">
                <el-checkbox style="width: 200px;" v-for="item in cityArr04" :label="item" :key="item">{{item}}</el-checkbox>
            </el-checkbox-group>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="success" @click="save">保存院校筛选条件</el-button>
           <el-button type="danger" @click="dialogVisible=false">取消并关闭</el-button>
  </span>
     </el-dialog>
</template>

<script>
import cityJson from "@/utils/city.json";
import {
  selectMajorForm,
  selectOneMajor,
  selectMajorList,
  screenFind,
  screenFindSave,
} from "@/api/admin/volunteer/selectMajor.js";
export default {
  data() {
    return {
      aspid: "",
      dialogVisible: false,
      loading: false,

      cityArr: cityJson, //城市选择
      indeterminate: true,
      checkAll: false, //地区是否全选
      cityCheckList: [], //选中的地区

      cityArr01: [
      "综合", "理工", "医药", "农林", "艺术", "民族", "语言", "师范", "财经", "体育", "政法", "军事", "其他","工农医"
      ], //院校类型
      indeterminate01: true,
      checkAll01: false,
      cityCheckList01: [],

      cityArr02: ["985", "211", "双一流", "其他"], //院校性质
      indeterminate02: true,
      checkAll02: false,
      cityCheckList02: [],

      cityArr03: [
        "公办",
        "民办",
        "独立学院",
        "解放军院校",
        "内地与港澳台地区合作办学",
        "中外合作办学",
      ], //院校属性
      indeterminate03: true,
      checkAll03: false,
      cityCheckList03: [],

      cityArr04: ["有博士点","有硕士点","其他"], //学校实力
      indeterminate04: true,
      checkAll04: false,
      cityCheckList04: [],
    };
  },
  mounted() {},
  watch: {
    dialogVisible(e) {
      if (e == false) {
        this.clearForm();
      }
    },
  },
  methods: {
    show() {
      this.$nextTick(() => {
        this.dialogVisible = true;
        //这里先获取筛选的数据
        this.aspid = this.$parent.detail.volunteer_id;
        this.screenFind(); //获取已经选择筛选的列表
      });
    },
    save() {
      // if(this.cityCheckList.length==0){
      //     this.$message.error("请至少选择一个省份");
      //     return;
      // }
      // if(this.cityCheckList01.length==0){
      //     this.$message.error("请至少选择一个院校类型");
      //     return;
      // }
      // if(this.cityCheckList02.length==0){
      //     this.$message.error("请至少选择一个院校性质");
      //     return;
      // }
      // if(this.cityCheckList03.length==0){
      //     this.$message.error("请至少选择一个院校属性");
      //     return;
      // }
      this.loading = true;
      let a = {
        cityCheckList: this.cityCheckList,
        cityCheckList01: this.cityCheckList01,
        cityCheckList02: this.cityCheckList02,
        cityCheckList03: this.cityCheckList03,
        cityCheckList04: this.cityCheckList04,
      };
      screenFindSave({
        aspid: this.aspid,
        name: "college_screen",
        value: JSON.stringify(a),
      })
        .then(() => {
          this.$notify({
          title: '保存院校筛选条件成功',
          message: '',
          type: 'success'
        });
          this.dialogVisible = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    screenFind() {
      this.loading = true;
      screenFind({
        aspid: this.aspid,
      })
        .then((res) => {
          console.log("院校筛选数据", res.data);
          if (res.data && res.data.college_screen) {
            let college_screen = JSON.parse(res.data.college_screen);
            console.log("院校筛选具体数据", college_screen);
            this.cityCheckList = college_screen.cityCheckList;
            this.cityCheckList01 = college_screen.cityCheckList01;
            this.cityCheckList02 = college_screen.cityCheckList02;
            this.cityCheckList03 = college_screen.cityCheckList03;
            this.cityCheckList04 = college_screen.cityCheckList04;
          }
          //地区选择
          if (this.cityCheckList.length == 0) {
              let city = [];
              cityJson.forEach((r) => {
                city.push(r.title);
              });
              this.cityCheckList = city;
          }
          //院校类型
          if(this.cityCheckList01.length==0){
            this.cityCheckList01 = [...this.cityArr01];
          }
          //院校性质
          if(this.cityCheckList02.length==0){
            this.cityCheckList02 = [...this.cityArr02];
          }
          //院校属性
          if(this.cityCheckList03.length==0){
            this.cityCheckList03 = [...this.cityArr03];
          }
          //学校实力
          if(this.cityCheckList04.length==0){
            this.cityCheckList04 = [...this.cityArr04];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //地区选择-选择具体的
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cityArr.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cityArr.length;
    },
    //地区选择-全选
    handleCheckAllChange(val) {
      let arr = [];
      this.cityArr.forEach((r) => {
        arr.push(r.title);
      });
      this.cityCheckList = val ? arr : [];
      this.isIndeterminate = false;
    },

    //地区选择-选择具体的
    handleCheckedCitiesChange01(value) {
      let checkedCount = value.length;
      this.checkAll01 = checkedCount === this.cityArr01.length;
      this.isIndeterminate01 =
        checkedCount > 0 && checkedCount < this.cityArr01.length;
    },
    //地区选择-全选
    handleCheckAllChange01(val) {
      let arr = [];
      this.cityArr01.forEach((r) => {
        arr.push(r);
      });
      this.cityCheckList01 = val ? arr : [];
      this.isIndeterminate01 = false;
    },

    //地区选择-选择具体的
    handleCheckedCitiesChange02(value) {
      // 当有城市被选中或取消选中时触发此方法
      if (value.includes("211")) {
        // 如果城市1被选中，同时选中城市2
        if (!value.includes("985")) {
          value.push("985");
        }
      }
      if (value.includes("双一流")) {
        if (!value.includes("211")) {
          value.push("211");
        }
        if (!value.includes("985")) {
          value.push("985");
        }
      } else if (value.includes("211")) {
        // 如果城市2被选中而城市1未被选中，取消选中城市2
        value.splice(value.indexOf("211"), "双一流");
      }
      let checkedCount = value.length;
      this.checkAll02 = checkedCount === this.cityArr02.length;
      this.isIndeterminate02 =
        checkedCount > 0 && checkedCount < this.cityArr02.length;
    },
    //地区选择-全选
    handleCheckAllChange02(val) {
      console.log(val);
      let arr = [];
      this.cityArr02.forEach((r) => {
        arr.push(r);
      });
      this.cityCheckList02 = val ? arr : [];
      this.isIndeterminate02 = false;
    },

    //地区选择-选择具体的
    handleCheckedCitiesChange03(value) {
      let checkedCount = value.length;
      this.checkAll03 = checkedCount === this.cityArr03.length;
      this.isIndeterminate03 =
        checkedCount > 0 && checkedCount < this.cityArr03.length;
    },
    //地区选择-全选
    handleCheckAllChange03(val) {
      let arr = [];
      this.cityArr03.forEach((r) => {
        arr.push(r);
      });
      this.cityCheckList03 = val ? arr : [];
      this.isIndeterminate03 = false;
    },
    //地区选择-选择具体的
    handleCheckedCitiesChange04(value) {
      let checkedCount = value.length;
      this.checkAll04 = checkedCount === this.cityArr04.length;
      this.isIndeterminate04 =
        checkedCount > 0 && checkedCount < this.cityArr04.length;
    },
    //地区选择-全选
    handleCheckAllChange04(val) {
      let arr = [];
      this.cityArr04.forEach((r) => {
        arr.push(r);
      });
      this.cityCheckList04 = val ? arr : [];
      this.isIndeterminate04 = false;
    },
    clearForm() {
      (this.indeterminate = true), (this.checkAll = false);
      this.cityCheckList = [];
      this.indeterminate01 = true;
      this.checkAll01 = false;
      this.cityCheckList01 = [];
      this.indeterminate02 = true;
      this.checkAll02 = false;
      this.cityCheckList02 = [];
      this.indeterminate03 = true;
      this.checkAll03 = false;
      this.cityCheckList03 = [];
      this.indeterminate04 = true;
      this.checkAll04 = false;
      this.cityCheckList04 = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.el-checkbox-group {
  background: #f8f9fa;
  padding-top: 20px;
  padding-left: 10px;
}
.el-checkbox {
  width: 102px;
  margin-bottom: 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/volunteer/components/selectCollege.vue